import React, { useEffect, useState, useCallback } from "react";
import TableComponentsCp from "../../Global Functions/tableComponentsCp";
import { useDispatch, useSelector } from "react-redux";
import {
  listRewardVouchers,
  updateRewardVoucher,
} from "../../Redux/Actions/rewardsAction"; 
import { columnsRewards } from "../../Global Functions/columnsAntd";
import toast from "react-hot-toast";

const ListRewards = () => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });
  const [tempSearch, setTempSearch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const dispatch = useDispatch();

  const fetchDetails = useCallback(
    (page, limit, showLoader = true) => {
      const payload = {
        page,
        limit,
        is_deleted: false,
        search: searchQuery,
      };
      dispatch(listRewardVouchers(payload, showLoader)).catch(() => {
        if (!showLoader) {
          toast.error("Failed to refresh reward history list");
        }
      });
    },
    [dispatch, searchQuery]
  );

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  // Reading vouchers state from rewardsReducer
  const rewardVouchers = useSelector((state) => state.rewards?.vouchers || {});
  const loading = useSelector((state) => state.rewards?.loading);

  useEffect(() => {
    if (rewardVouchers?.total) {
      setPagination((prevData) => ({
        ...prevData,
        total: rewardVouchers.total,
      }));
    }
  }, [rewardVouchers]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    // fetchDetails(pagination.current, pagination.pageSize);
  };

  const filterHandler = () => {
    setSearchQuery(tempSearch);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleStatusChange = async (record, action) => {
    let payload = { id: record._id };

    if (action === "primary") {
      payload.primary = true; // send true
    } else if (action === "remove-primary") {
      payload.primary = false; // send false
    } else {
      payload.status = action; // for active/inactive
    }
    await dispatch(updateRewardVoucher(payload));
    fetchDetails(pagination.current, pagination.pageSize);

  };

  return (
    <TableComponentsCp
      h3heading="Reward Voucher List"
      pagination={pagination}
      onChange={handleTableChange}
      columns={columnsRewards(handleStatusChange)}
      buttonhead2="Add Reward Voucher"
      navigateTo2="/rewards_voucher/add"
      dataSource={
        Array.isArray(rewardVouchers?.data) ? rewardVouchers.data : []
      }
      loading={loading}
      setState={setTempSearch}
      filterFunction={filterHandler}
    />
  );
};

export default ListRewards;
